import * as Yup from 'yup';

export const VerificationSchema = Yup.object().shape({
  license: Yup.string().required('Upload your license'),
  facilityId: Yup.string().required('Enter degree name'),
  cacCertificate: Yup.string().required('Please upload degree certificate'),
});

export type VerificationDataType = Yup.InferType<typeof VerificationSchema>;

type InitialValues = {
  license: string;
  facilityId: string;
  cacCertificate: string;
};

export const VerificationInitialValues: InitialValues = {
  license: '',
  facilityId: '',
  cacCertificate: '',
};
